jQuery(document).ready(function ($) {
  var w = window.innerWidth;
  if (w < 768) {
    $(window).scroll(function () {
      scroll = jQuery(window).scrollTop();

      if (scroll >= 450) jQuery(".chat-now").addClass("active");
      else jQuery(".chat-now").removeClass("active");
    });
  }

  $("#find-your-printer-form").submit(function (event) {
    event.preventDefault(); // Prevent the default form submission

    var submitBtn = $("#find-printer-qwuery-submit");
    submitBtn.prop("disabled", true);
    var btnText = submitBtn.find(".btn-text");
    var loaderText = submitBtn.find(".loader-text");

    btnText.hide();
    loaderText.show();
    $(".c-results").show();

    var formData = $(this).serialize();
    var t = $(this);

    // Call to Copean Code & Quoations Emails
    $.ajax({
      type: "POST",
      // Oct 27 2026: Bodno's own quiz backend (Supabase quiz-lead). The old developer finder server is no longer called at all.
      url: "https://ekpavfdzsrfathpwjrwu.supabase.co/functions/v1/quiz-lead?op=submit",
      data: formData,
      dataType: "json",
      success: function (data) {},
      complete: function (data) {},
      error: function (xhr, status, error) {},
    });

    // Show the Messages
    document
      .querySelector(".estimated-delivery")
      .setAttribute("style", "display: block !important;");
    document.querySelector(".custom-progress-bar").style.display = "none";
    document.querySelector(".selected_options h2").style.display = "none";
    document.querySelector("#in-work").style.display = "block";

    if (window.innerWidth <= 992) {
      document.querySelector(".find-your-printer .row").style.flexDirection =
        "column";
      document.querySelector(
        "#find-your-printer-body-selected-options"
      ).style.marginBottom = "20px";
      const scrollElement1 = document.getElementById("find-your-printer-form");
      const elementPosition1 =
        scrollElement1.getBoundingClientRect().top + window.pageYOffset; // Get element's position relative to the viewport

      // Scroll to the element with a custom offset
      window.scrollTo({
        top: elementPosition1 - 160, // Adjust top position by the offset
        behavior: "smooth", // Smooth scroll behavior
      });

      document.querySelector(".selected_options h2").style.marginBottom =
        "20px";
    }

    $("#find-your-printer-form").hide();

    document.querySelector(".quiz-header-text").textContent =
      "Your Perfect Printer Is Here";
    document.querySelector("#in-work").style.display = "none";
    document.querySelector(".form-step-heading-6.active").style.display =
      "none";

    submitBtn.prop("disabled", false);

    var serializedData = formData;
    var targetString = "filter.p.m.info.os_compatibillity=both";
    var newString =
      "filter.p.m.info.os_compatibillity=Windows&filter.p.m.info.os_compatibillity=Mac";
    if (serializedData.includes(targetString)) {
      serializedData = serializedData.replace(targetString, newString);
    }

    $("#ajax-loader").show();
    $.get("/collections/id-card-printers?" + serializedData, function (data) {
      var products_list = $(data).find("#product-grid").html();
      $("#find-your-printer-form").hide();
      $("#product-grid").html(products_list);
      $("#product-grid li").hide();
      $("#product-grid li:nth-child(1),#product-grid li:nth-child(2)").show();
      $("#product-grid li:nth-child(1) .product-inner-wrapper").prepend(
        '<span class="opt">Option #1</span>'
      );
      $("#product-grid li:nth-child(2) .product-inner-wrapper").prepend(
        '<span class="opt">Option #2</span>'
      );
    }).always(function () {
      $("#ajax-loader").hide();
    });
    btnText.show(); // Show the submit text again
    loaderText.hide();
    $(".estimated-delivery").css("display", "block !important;");
  });

  // function bodno_mailer(data,variants){
  //   var name_input = data.find('[name="fullname"]').val();
  //   var email_input = data.find('[name="email_address"]').val();
  //   var phone_input = data.find('[name="phone"]').val();
  //   var qty_input = 1;
  //   var variant_id_input = variants[0];
  //   var from_input = 'PrinterFinder';

  //   $.ajax({
  //   url: (old developer quote emailer, removed Oct 27 2026)
  //   type: "post",
  //   data: JSON.stringify({name:name_input,email:email_input,variant:variant_id_input,phone:phone_input,qty:qty_input,from:from_input}),
  //   success: function (response) {
  //     $('#quote').hide();
  //     $('#self-quote .success-msg').show();
  //     return;
  //   }
  //   });
  // }function bodno_mailer_two(data,variants){
  //   var name_input = data.find('[name="fullname"]').val();
  //   var email_input = data.find('[name="email_address"]').val();
  //   var phone_input = data.find('[name="phone"]').val();
  //   var qty_input = 1;
  //   var variant_id_input = variants[1];
  //   var from_input = 'PrinterFinder';

  //   $.ajax({
  //   url: (old developer quote emailer, removed Oct 27 2026)
  //   type: "post",
  //   data: JSON.stringify({name:name_input,email:email_input,variant:variant_id_input,phone:phone_input,qty:qty_input,from:from_input}),
  //   success: function (response) {
  //     $('#quote').hide();
  //     $('#self-quote .success-msg').show();
  //     return;
  //   }
  //   });
  // }
  jQuery("ul.notes-tabs-list li").on("click", function () {
    jQuery(this).addClass("active");
    jQuery(this).siblings().removeClass("active");
    var tabid = jQuery(this).attr("data-id");
    jQuery("#" + tabid).addClass("show");
    jQuery("#" + tabid)
      .parent()
      .siblings()
      .find(".accordion-collapse")
      .removeClass("show");
  });
  jQuery(".filter-options-title").on("click", function () {
    jQuery(this).parent().toggleClass("active");
    jQuery(this).parent().find(".filter-options-list").slideToggle();
  });
  jQuery(".filter-title strong").on("click", function () {
    jQuery(".filters-wrapper").slideToggle();
  });
  //sticky-header

  jQuery(window).scroll(function () {
    var stickyheader = jQuery(".header-wrapper"),
      scroll = jQuery(window).scrollTop();

    if (scroll >= 200) stickyheader.addClass("header-fixed");
    else stickyheader.removeClass("header-fixed");
    var Topbar = jQuery(".topbar-wrapper");
    if (scroll >= 200) Topbar.css("margin-bottom", "140px");
    else Topbar.css("margin-bottom", "0");

    var BackToTop = jQuery("#back-top");

    if (scroll >= 200) BackToTop.css("display", "block");
    else BackToTop.css("display", "none");
  });

  jQuery(".mega-menu ul.main-menu > li").on("mouseover", function () {
    jQuery(this).find("ul.megamenu-dropdown").css("display", "block");
    jQuery(this).find(".desktop-icon").addClass("show-icon");
    
  });
  jQuery(".mega-menu ul.main-menu > li").on("mouseleave", function () {
    jQuery(this).find("ul.megamenu-dropdown").css("display", "none");
     jQuery(this).find(".desktop-icon").removeClass("show-icon");
  });

  // mobile-menu
  jQuery("li.has-dropdown-menu").each(function () {
    jQuery(this).append(
      '<span class="mobilemenutoggler"><i class="fas fa-chevron-right"></i></span>'
    );
  });

  jQuery(".nav-toggle:not(.nav-open)").on("click", function () {
    jQuery("body").append(
      '<div class="modal-backdrop fade show for-menu"></div>'
    );
    jQuery("body").addClass("menu-open");
    jQuery(".mobile-menu").addClass("open");
  });
  jQuery(".nav-toggle.nav-open").on("click", function () {
    jQuery(".modal-backdrop").remove();
    jQuery("body").removeClass("menu-open");
    jQuery(".mobile-menu").removeClass("open");
  });
  jQuery("span.mobilemenutoggler").on("click", function () {
    jQuery(this).find("i").toggleClass("fa-chevron-right fa-times");
    jQuery(this).parent().find("ul.mobile-dropdown").slideToggle();
  });

  // faq

  jQuery(".faq-question").on("click", function () {
    jQuery(".faq-answer").removeClass("active");
    //jQuery(this).parent().addClass('active');
    jQuery(this).parent().toggleClass("active");

    jQuery(this).next().slideToggle();
    jQuery(this).parent().siblings().removeClass("active");
    jQuery(this).parent().siblings().find(".faq-answer").slideUp("active");
  });
  if ($(window).width() <= 767) {
    jQuery(
      ".hub-section-7 .custom-options, .industry-section-3 .industry-printer-boxes"
    ).slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode: true,
    });

    jQuery(".hub-section-5 .testi-boxes, .case-studyrow").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
    });
  }

  if ($(window).width() <= 992) {
    jQuery(".vc_boxes ").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    jQuery(".s-242").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 535,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
if ($(window).width() >= 993) {
  jQuery(".section-no-198 .vc_boxes").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    jQuery(".section-no-204 .vc_boxes").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
    jQuery(".section-no-210 .s-210").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });



   jQuery(".guide-boxes").slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
      {
        breakpoint: 1250,
        settings: {
           arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 993,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    });

    jQuery(".parts-printers-guide-boxes").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
      {
        breakpoint: 1250,
        settings: {
           arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 993,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    });

    jQuery(".parts-printers-blog-boxes").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
      {
        breakpoint: 1250,
        settings: {
           arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 993,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    });

   jQuery(".blog-boxes").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
      {
        breakpoint: 1250,
        settings: {
           arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 993,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    });

  jQuery("#Testimonila_Slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  jQuery("#Testimonila_Card_Slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow:
      "<button type='button' class='slick-prev slick-arrow' aria-disabled='true'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next slick-arrow' aria-disabled='true'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 993,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  jQuery(".supply-carousel").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  jQuery(".org-boxes").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 3,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  jQuery(".org-boxes-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
            arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  if ($(window).width() > 767) {
    jQuery(".org-boxes-new").slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 1081,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });
  }

  jQuery(".idcp-12-boxes").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  jQuery(".sec-no-102-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

    jQuery(".sec-no-103-slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  jQuery(".sec-no-106-slider, .printer-type-box ").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    dots: true,
  });

  

  jQuery(".quotations-col-boxes").slick({
    infinite: false,
    // speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    //autoplay:true,
  });

  jQuery(".navslider-quote-slider").slick({
    // autoplay: true,
    speed: 1000,
    arrows: false,
    dots: false,
    asNavFor: ".testimonial-navslider-thumbs",

    responsive: [
      {
        breakpoint: 768,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });
  jQuery(".testimonial-navslider-thumbs").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    speed: 1000,
    dots: false,
    asNavFor: ".navslider-quote-slider",
    responsive: [
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

   jQuery(".supplies-boxes").slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: true,
      dots: true,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
      {
        breakpoint: 1250,
        settings: {
           arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 993,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    });

  
   $('a[data-bs-toggle="tab"]').on("shown.bs.tab", function (e) {
    $(".supplies-boxes, .sec-no-102-slider").slick("setPosition");
  });

  jQuery("#reviews-software").owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      1000: {
        items: 3,
        loop: false,
      },
    },
  });
  jQuery("#why-choose-bodno").owlCarousel({
    loop: false,
    margin: 24,
    nav: false,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        dots: true,
      },
      481: {
        items: 2,
        dots: true,
        margin: 10,
      },
      993: {
        items: 3,
        dots: true,
      },
      1081: {
        items: 4,
        loop: false,
      },
    },
  });
  jQuery("#latest-blogs").owlCarousel({
    loop: true,
    margin: 30,
    nav: false,
    dots: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      630: {
        items: 2,
        autoplay: true,
        margin: 20,
      },
      1081: {
        items: 3,
      },
    },
  });
  jQuery("#similar-printers-carousel").owlCarousel({
    loop: false,
    margin: 24,
    nav: true,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        margin: 0,
      },
      600: {
        items: 2,
        margin: 10,
      },
      992: {
        items: 3,
      },
      1120: {
        items: 4,
        loop: false,
      },
    },
  });
  jQuery(".best-selling-printers-carousel").owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        margin: 0,
        nav: false,
        dots: true,
      },
      600: {
        items: 2,
        margin: 10,
        nav: false,
        dots: true,
      },
      992: {
        items: 3,
      },
      1120: {
        items: 4,
      },
      1700: {
        items: 4,
      },
    },
  });
  jQuery(".best-selling-printers-carousel-2").owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        margin: 0,
        nav: false,
        dots: false,
      },
      600: {
        items: 2,
        margin: 10,
        nav: false,
        dots: false,
      },
      992: {
        items: 2,
      },
      1120: {
        items: 2,
      },
      1700: {
        items: 2,
      },
    },
  });

  jQuery("#printing-id-cards").owlCarousel({
    loop: false,
    margin: 0,
    nav: true,
    dots: false,
    responsiveClass: true,
    autoplay: true,
    autoPlaySpeed: 5000,
    autoPlayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        margin: 0,
      },
      600: {
        items: 2,
        margin: 10,
      },
      992: {
        items: 3,
      },
      1120: {
        items: 4,
        loop: false,
      },
    },
  });

  jQuery("#product-media-main-image").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    asNavFor: "#product-media-thumbnail-image",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          asNavFor: "",
        },
      },
    ],
  });

  jQuery("#product-media-thumbnail-image").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: "#product-media-main-image",
    arrows: true,
    infinite: false,
    vertical: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToScroll: 1,
          dots: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          dots: false,
          slidesToShow: 4,
        },
      },
    ],
  });

  jQuery(".why_choose_bodno_wrapper").owlCarousel({
    loop: false,
    margin: 24,
    nav: false,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 2,
        dots: true,
      },
      1024: {
        items: 4,
        loop: false,
      },
    },
  });

  if (window.matchMedia("(max-width: 767px)").matches) {
    $(
      ".idcp-5-boxes, .idcp-7-boxes-key-features, .idcp-7-boxes-glossary"
    ).slick({
      infinite: true,
      // speed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      //autoplay: true,
      centerMode: false,
      //centerPadding: '20px',
    });

   

    jQuery(".description-g-boxes").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });

   
     jQuery(".s-185-boxes").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
    });

      jQuery(".section-no-196 .industry-boxes ").slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true,
        dots: true,
      });

    jQuery(".pg-step-9").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      centerMode: true,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 550,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    jQuery(".s-247-slider").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      centerMode: true,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 550,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

      

  }

  $('a[data-bs-toggle="tab"]').on("shown.bs.tab", function (e) {
  
    $(
      ".idcp-5-boxes, .idcp-7-boxes-key-features, .idcp-7-boxes-glossary"
    ).slick("setPosition");
  });

  jQuery("#GetStarted").click(function () {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery("#software-demo-download").offset().top,
      },
      500
    );
  });

  jQuery(".number_of_cards").keyup(function () {
    var number_of_cards = jQuery(".number_of_cards").val();
    if (number_of_cards == 0) {
      number_of_cards = 1;
    }

    jQuery(".price_per_card").each(function () {
      var price = jQuery(this).data("price");
      var sku = jQuery(this).data("sku");
      var c = jQuery(this).data("c");
      var final_price = price * number_of_cards;

      jQuery(".card-price-" + sku + "-c-" + c + " .final_price").text(
        "$" + final_price.toFixed(2)
      );
    });
  });

  jQuery("#brand_name").change(function () {
     if (jQuery("#brand_name").val() == "bodno-a-series") {
      jQuery("#printer_compatibility").html(
        '<option value="">Please Select</option><option value="/collections/bodno-a10-id-card-printer-supplies">Bodno A10</option><option value="/collections/bodno-a20-id-card-printer-supplies">Bodno A20</option><option value="/collections/bodno-a30-id-card-printer-supplies">Bodno A30</option><option value="/collections/bodno-a40-pro-id-card-printer-supplies">Bodno A40 PRO</option>'
      );
    }
    if (jQuery("#brand_name").val() == "evolis") {
      jQuery("#printer_compatibility").html(
        '<option value="">Please Select</option><option value="/collections/evolis-badgy100-supplies">Evolis Badgy 100</option><option value="/collections/evolis-badgy200-supplies">Evolis Badgy 200</option><option value="/collections/evolis-primacy-supplies">Evolis Primacy</option><option value="/collections/evolis-primacy2-supplies">Evolis Primacy 2</option><option value="/collections/evolis-zenius-supplies">Evolis Zenius</option>'
      );
    }
    if (jQuery("#brand_name").val() == "fargo") {
      jQuery("#printer_compatibility").html(
        '<option value="/collections/fargo-dtc1250e-supplies">Fargo DTC1250e</option><option value="/collections/fargo-dtc4250e-supplies">Fargo DTC4250e</option><option value="/collections/fargo-dtc4500e-supplies">Fargo DTC4500e</option><option value="/collections/fargo-hdp5000-supplies">Fargo HDP5000</option><option value="/collections/fargo-hdp5000e-id-card-printer-supplies">Fargo HDP5000e</option><option value="/collections/fargo-hdp6600-supplies">Fargo HDP6600</option>'
      );
    }

    if (jQuery("#brand_name").val() == "idp") {
      jQuery("#printer_compatibility").html(
        '<option value="">Please Select</option><option value="/collections/idp-smart31-supplies">IDP Smart31</option><option value="/collections/idp-smart51-supplies">IDP Smart51</option><option value="/collections/idp-smart70-supplies">IDP Smart70</option>'
      );
    }
    if (jQuery("#brand_name").val() == "magicard") {
      jQuery("#printer_compatibility").html(
        '<option value="">Please Select</option><option value="/collections/magicard-pronto-supplies">Magicard Pronto</option><option value="/collections/magicard-pronto100-supplies">Magicard Pronto 100</option><option value="/collections/magicard-enduro-3e-supplies">Magicard Enduro 3e</option><option value="/collections/magicard-rio-pro-360-supplies">Magicard Rio Pro 360</option><option value="/collections/magicard-300-supplies">Magicard 300</option><option value="/collections/magicard-400x-id-card-printer-supplies">Magicard 400x</option><option value="/collections/magicard-600-supplies">Magicard 600</option><option value="/collections/magicard-ultima-supplies">Magicard Ultima</option>'
      );
    }
    if (jQuery("#brand_name").val() == "matica") {
      jQuery("#printer_compatibility").html(
        '<option value="">Please Select</option><option value="/collections/matica-mc320-supplies">Matica MC320</option>'
      );
    }
    if (jQuery("#brand_name").val() == "zebra") {
      jQuery("#printer_compatibility").html(
        '<option value="">Please Select</option><option value="/collections/zebra-zc100-supplies">Zebra ZC100</option><option value="/collections/zebra-zc300-supplies">Zebra ZC300</option><option value="/collections/zebra-zc350-supplies">Zebra ZC350</option><option value="/collections/zebra-zxp3-supplies">Zebra ZXP Series 3</option><option value="/collections/zebra-zxp7-supplies">Zebra ZXP7</option>'
      );
    }
    if (jQuery("#brand_name").val() == "seaory") {
      jQuery("#printer_compatibility").html(
        '<option value="">Please Select</option><option value="/collections/seaory-s25-supplies">Seaory S25</option><option value="/collections/seaory-s26-supplies">Seaory S26</option><option value="/collections/seaory-s28-supplies">Seaory S28</option><option value="/collections/seaory-r330-supplies">Seaory R330</option><option value="/collections/seaory-r660-supplies">Seaory R660</option>'
      );
    }
  });

  jQuery("#find-supplies").click(function () {
    var location = jQuery("#printer_compatibility").val();
    if (location) {
      window.location.replace(location);
    }
  });

  jQuery(".recover-password").click(function () {
    jQuery(".login-form").hide();
    jQuery(".forgot-form").show();
  });

  jQuery(".back-login").click(function () {
    jQuery(".login-form").show();
    jQuery(".forgot-form").hide();
  });

  /*
  jQuery(document).delegate("._thumbnail", "mouseover", function(e) {
    jQuery('.__featured_image').attr('src', jQuery(this).data("image"));
    jQuery('.product-media-main-image a').attr('href', jQuery(this).data("image"));
    jQuery('._thumbnail').removeClass('__active');
    jQuery(this).addClass('__active');

    jQuery('.prev-image').data('id', parseFloat(jQuery(this).data("image-id")) - 1);
    jQuery('.next-image').data('id', parseFloat(jQuery(this).data("image-id")) + 1);
  });
  jQuery(document).delegate("._thumbnail", "click", function(e) {
    jQuery('.__featured_image').attr('src', jQuery(this).data("image"));
    jQuery('.product-media-main-image a').attr('href', jQuery(this).data("image"));
    jQuery('._thumbnail').removeClass('__active');
    jQuery(this).addClass('__active');

    jQuery('.prev-image').data('id', parseFloat(jQuery(this).data("image-id")) - 1);
    jQuery('.next-image').data('id', parseFloat(jQuery(this).data("image-id")) + 1);
  });

  jQuery(document).delegate(".prev-image", "click", function(e) {
    var _image_id = jQuery(this).data("id");
    if (jQuery('._thumbnail_'+_image_id).length > 0) {
     
        jQuery(this).data('id', parseFloat(_image_id) - 1);  
        jQuery('.next-image').data('id', parseFloat(_image_id) + 1);
        var selected_image = jQuery('._thumbnail_'+_image_id);
        jQuery('.__featured_image').attr('src', selected_image.data("image"));
        jQuery('.product-media-main-image a').attr('href', selected_image.data("image"));
        jQuery('._thumbnail').removeClass('__active');
        jQuery('._thumbnail_'+_image_id).addClass('__active');
    
    }
    
  
  });
  jQuery(document).delegate(".next-image", "click", function(e) {
    var _image_id = jQuery(this).data("id");
    if (jQuery('._thumbnail_'+_image_id).length > 0) {
      jQuery(this).data('id', parseFloat(_image_id) + 1);
      jQuery('.prev-image').data('id', parseFloat(_image_id) - 1);

      var selected_image = jQuery('._thumbnail_'+_image_id);

      jQuery('.__featured_image').attr('src', selected_image.data("image"));
      jQuery('.product-media-main-image a').attr('href', selected_image.data("image"));
      jQuery('._thumbnail').removeClass('__active');
      jQuery('._thumbnail_'+_image_id).addClass('__active');

      
      
    }
  
  });
  */

  jQuery(".swatch-option").on("click", function () {
    $(this)
      .closest(".swatch-attribute-options")
      .children(".swatch-option")
      .removeClass("selected");
    jQuery(this).addClass("selected");
    $(this)
      .closest(".swatch-attribute")
      .children(".swatch-attribute-selected-option")
      .text(jQuery(this).children("label").text());

    var selected = jQuery(this).data("value");
    var type = jQuery(this).data("type");
    if (type == "color") {
      jQuery(".software-description").hide();
      jQuery("." + selected).show();
    }
    if (type == "size") {
      jQuery(".software-type").hide();
      jQuery("." + selected).show();
    }
  });

  jQuery(document).delegate(".__fbt_check", "change", function (e) {
    var totalPrice = 0;
    var count = 0;
    jQuery("input:checkbox.__fbt_check").each(function () {
      if (jQuery(this).is(":checked")) {
        totalPrice += parseFloat(jQuery(this).data("price"));
        count++;
        jQuery(".__fbt_" + jQuery(this).data("id")).removeClass("__ftb_hide");
      } else {
        jQuery(".__fbt_" + jQuery(this).data("id")).addClass("__ftb_hide");
      }
    });
    jQuery(".__fbt_total").text(Shopify.formatMoney(totalPrice));
    jQuery(".__fbt_add_to_cart b").text(count);
  });

  jQuery(document).on("click", ".__software-pricing", function () {
    jQuery(".software-pricing li").removeClass("active");
    jQuery(this).addClass("active");

    var type = jQuery(this).attr("data-type");
    jQuery(".software-pricing-type").hide();
    jQuery(".software-pricing-bar-info").hide();
    jQuery("." + type).show();
  });

  // 🔥 Trigger yearly click on page load
  jQuery(document).ready(function () {
    jQuery(".__software-pricing[data-type='__yearly']").trigger("click");

    
  });

  jQuery(document).ready(function ($) {
    const params = new URLSearchParams(window.location.search);
    const typeFromUrl = params.get("type"); // __monthly | __yearly | __onetime

    let $target;

    if (typeFromUrl && $(`.__software-pricing[data-type="${typeFromUrl}"]`).length) {
      // 🔹 Trigger based on URL
      $target = $(`.__software-pricing[data-type="${typeFromUrl}"]`);
    } else {
      // 🔹 Fallback default (yearly)
      $target = $('.__software-pricing[data-type="__yearly"]');
    }

    // 🔥 Trigger click ONLY once, correctly
    $target.trigger("click");
  });

  // Fix for dynamically loaded .__support-pricing elements
  jQuery(document).on("click", ".__support-pricing", function () {
    jQuery(".support-pricing li").removeClass("active");
    jQuery(this).addClass("active");

    var type = jQuery(this).attr("data-type");
    if (type != "__onetime") {
      jQuery(".support-pricing-type").hide();
      jQuery("." + type).show();
      jQuery(".__bodno-surpport-subscription").show();
      jQuery(".__bodno-surpport-onetime").hide();
    } else {
      jQuery(".__bodno-surpport-subscription").hide();
      jQuery(".__bodno-surpport-onetime").show();
    }
  });

  jQuery(".license-key").mask("CC-AAAA-AAAA-AAAA");
  //jQuery(".license-key").attr("placeholder", "CC-____-____-____");

  jQuery(".activation-key").mask("AAAA-AAAA-AAAA-AAAA-AAAA");
  //jQuery('.activation-key').attr("placeholder", "____-____-____-____-____");

  jQuery(".upgrade-now").on("click", function () {
    jQuery(".upgrade-selected").val(jQuery(this).data("id"));
  });

  // var amazon_order=[{"mask":"***-*******-******"},{"mask":"***-*******-******"}];
  // jQuery('#amazon_order').inputmask({mask:amazon_order,clearIncomplete:true,greedy:false});
  // jQuery('#amazon_order').attr("placeholder", "***-*******-******");

  // var bodno_order=[{"mask":"*********"},{"mask":"*********"}];
  // jQuery('#bodno_order').inputmask({mask:bodno_order,clearIncomplete:true,greedy:false});
  // jQuery('#bodno_order').attr("placeholder", "*********");

  //   jQuery(document).delegate(".selected_variant", "change", function(e) {
  //     var selected = jQuery(this).val();
  //     var name = variants_info[selected]['_name'];
  //     var description = variants_info[selected]['_description'];
  //     var short_description = variants_info[selected]['_short_description'];

  //     jQuery('.product-page-title').text(name);
  //     jQuery('.prod-description').html(htmlDecode(description));
  //     jQuery('.short_description').html(htmlDecode(short_description));

  //   });

  //   function htmlDecode(input) {
  //     var doc = new DOMParser().parseFromString(input, "text/html");
  //     return doc.documentElement.textContent;
  //   }

  jQuery(".license-key").on("keyup click", function () {
    jQuery("#_license-key").val(jQuery(this).val());
  });

  jQuery("#facility-code").on("keyup click", function () {
    jQuery("#_facility-code").val(jQuery(this).val());
  });

  jQuery("#sequence-code").on("keyup click", function () {
    jQuery("#_sequence-code").val(jQuery(this).val());
  });

  jQuery("#facility-code").on("keyup click", function () {
    jQuery("#_facility-code").val(jQuery(this).val());
  });

  jQuery("#activation-key").on("keyup click", function () {
    jQuery("#_activation-key").val(jQuery(this).val());
  });


  jQuery("#quote-btn").on("click", function () {
    jQuery("#__quote-btn").click();
  });
  jQuery("#quote-btn-m").on("click", function () {
    jQuery(".modal-backdrop").remove();
    jQuery("body").removeClass("menu-open");
    jQuery(".mobile-menu").removeClass("open");
    jQuery("#__quote-btn").click();
  });

  function validateEmail(email) {
  var emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailReg.test(email);
}

  jQuery(document).on("click", "#submit_quote", function (e) {
    e.preventDefault();

    var first_name_input = jQuery('input[id="quote_first_name"]').val();
    var last_name_input = jQuery('input[id="quote_last_name"]').val();
    var email_input = jQuery('input[id="quote_email"]').val();
    var phone_input = jQuery('input[id="quote_phone"]').val();
    var qty_input = jQuery(".pdp-qty .qty").val();
    console.log(qty_input);
    var variant_id_input = jQuery(".selected_variant").find(":selected").val();

    if (first_name_input == "undefined" || first_name_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your First Name!</div>'
      );
      return;
    }

    if (last_name_input == "undefined" || last_name_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Last Name!</div>'
      );
      return;
    }

    if (email_input == "undefined" || email_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Email!</div>'
      );
      return;
    }

    if (phone_input == "undefined" || phone_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Phone Number!</div>'
      );
      return;
    }

    if (!validateEmail(email_input)) {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter A Valid Email!</div>'
      );
      return;
    }

    if (
      email_input !== "undefined" &&
      first_name_input !== "undefined" &&
      last_name_input !== "undefined" &&
      phone_input !== "undefined" &&
      variant_id_input !== "undefined"
    ) {

      console.log(variant_id_input);
      jQuery(".error-msg").hide();
      jQuery.ajax({
        // Oct 27 2026: Bodno's own quote system (Supabase quiz-lead op self_quote), replaces the old developer quote emailer
        url: "https://ekpavfdzsrfathpwjrwu.supabase.co/functions/v1/quiz-lead?op=self_quote",
        type: "post",
        data: JSON.stringify({
          first_name: first_name_input,
          last_name: last_name_input,
          email: email_input,
          variant: variant_id_input,
          phone: phone_input,
          qty: qty_input,
          page: location.href.split('#')[0],
        }),
        error: function (xhr) {
          var msg = 'We could not send the quote. Call (732) 987-5300 and we will email it right away.';
          try { if (xhr.responseJSON && xhr.responseJSON.error) msg = xhr.responseJSON.error; } catch (e) {}
          jQuery('#self-quote .error-msg').text(msg).show();
        },
        success: function (response) {
          // jQuery("form#quote").hide();
          // jQuery("#self-quote .success-msg").show();
          // Hide #self-quote modal if already shown
            const selfModalEl = document.getElementById('self-quote');
            const selfModalInstance = bootstrap.Modal.getInstance(selfModalEl);
            if (selfModalInstance) {
              selfModalInstance.hide();
            }
        
            // Show #customModal1 modal
            const customModalEl = document.getElementById('customModal2');
            const customModalInstance = new bootstrap.Modal(customModalEl);
            customModalInstance.show();
          return;
        },
      });
    }
  });

  // jQuery(".warranty-product-variants").on("change", function (e) {
  //   var new_product_price = $("#new_product_price");
  //   var imgDiv = $(".product_img img");
  //   var new__atc = $(".new__atc");

  //   var valueSelected = "";
  //   jQuery(".warranty-product-variants").each(function () {
  //     var optionSelected = $("option:selected", this);
  //     valueSelected = valueSelected + this.value + " / ";
  //   });
  //   valueSelected = valueSelected.substring(0, valueSelected.length - 3);
  //   if (!valueSelected.includes("Select")) {
  //     jQuery(".p_all_varaints option").each(function () {
  //       let option = $(this);
  //       if (option.text().trim() == valueSelected) {
  //         option.attr("selected", false);
  //         let price = option.attr("data-v_price");
  //         let soldout = option.attr("data-v_soldout");
  //         let img = option.attr("data-v_img");

  //         new_product_price.text(price);
  //         if (soldout == "soldout") {
  //           new__atc.prop("disabled", true);
  //           new__atc.text("Unavailable");
  //         } else {
  //           new__atc.prop("disabled", false);
  //           new__atc.text("Add to cart");
  //         }

  //         imgDiv.attr("src", img);

  //         option.attr("selected", "selected");
  //         return false;
  //       } else {
  //         new__atc.prop("disabled", true);
  //         new__atc.text("Unavailable");
  //       }
  //     });
  //   }
  // });


jQuery(document).on("change", ".warranty-box .warranty-product-variants", function () {
  var warrantyBox = jQuery(this).closest(".warranty-box"); // scope to warranty-box parent

  var new_product_price = warrantyBox.find(".new_product_price"); 
   var imger = warrantyBox.find(".imager-new"); 
  var imgDiv = warrantyBox.find(".imager-new img"); 
  var new__atc = warrantyBox.find(".new__atc");
  var allVariantsSelect = warrantyBox.find(".p_all_varaints");

  var valueSelected = "";
  warrantyBox.find(".warranty-product-variants").each(function () {
    valueSelected += this.value + " / ";
  });
  valueSelected = valueSelected.slice(0, -3); // remove last " / "

  if (!valueSelected.includes("Select")) {
    allVariantsSelect.find("option").each(function () {
      let option = jQuery(this);

      if (option.text().trim() === valueSelected) {
        option.prop("selected", true);

        let price = option.attr("data-v_price");
        let soldout = option.attr("data-v_soldout");
        let img = option.attr("data-v_img");

        new_product_price.text(price);
        imger.show(); 
        imgDiv.attr("src", img);

        if (soldout === "soldout") {
          new__atc.prop("disabled", true).text("Unavailable");
        } else {
          new__atc.prop("disabled", false).text("Add to cart");
        }

        return false; // exit loop
      }
    });
  } else {
    new__atc.prop("disabled", true).text("Unavailable");
  }
});

  jQuery(".link_to").click(function () {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".new_warranty_hand_coverd").offset().top,
      },
      500
    );
  });

  jQuery(".list-card").on("click", function () {
    jQuery(".list-card").removeClass("active");
    jQuery(this).addClass("active");
    jQuery(".leas_img").hide();
    jQuery(".leas_img." + jQuery(this).data("image")).show();
  });

  /**********************************  printer setup js **********************************/

  // menu bar button click
  jQuery("body").on("click", ".new__printer__steps li", function () {
    jQuery(".new__printer__steps li").removeClass("activeLi");
    jQuery(this).addClass("activeLi");
    jQuery(".step").removeClass("active");
    jQuery(".step").each(function () {
      if (
        jQuery(this).attr("data-class") ==
        jQuery(".new__printer__steps li.activeLi").attr("data-class")
      ) {
        jQuery(this).addClass("active");
      }
    });
  });

  // next button click
  jQuery("body").on("click", ".next-btn,.previous-btn", function () {
    jQuery(".new__printer__steps li").removeClass("activeLi");
    jQuery(".new__printer__steps li").each(function () {
      if (
        jQuery(this).attr("data-class") ==
        jQuery(".step.active").attr("data-class")
      ) {
        jQuery(this).addClass("activeLi");
      }
    });
  });

  // on select change, load the link of printer
  jQuery("body").on("change", ".new__printer__select select", function () {
    var optionSelected = jQuery("option:selected", this);
    var valueSelected = optionSelected.attr("data-value");

    if (valueSelected != undefined) {
      jQuery(".new__printer__select__url").html(valueSelected);
      jQuery(".new__printer__select__url").attr("href", valueSelected);
      jQuery(".new__printer__select__url").css("display", "inline-block");
    } else {
      jQuery(".new__printer__select__url").css("display", "none");
    }
  });

  /**********************************  printer setup js **********************************/

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  jQuery(".register-your-printer .steps li").on("click", function () {
    //jQuery('.register-your-printer .steps li').siblings().removeClass('active');
    //jQuery(this).addClass('active');
    //jQuery('.register-your-printer-page').hide();
    //jQuery('.'+jQuery(this).attr('data-page')).show();
  });

  jQuery(".step-button").on("click", function () {
    jQuery(".register-your-printer .steps li").removeClass("active");
    jQuery(
      '.register-your-printer .steps li[data-page="' +
        jQuery(this).attr("data-page") +
        '"]'
    ).addClass("active");
    jQuery(".register-your-printer-page").hide();
    jQuery("." + jQuery(this).attr("data-page")).show();
  });

  jQuery("input[type=radio][name=order_from]").change(function () {
    jQuery("input#bodno_order").val("");
    jQuery("input#amazon_order").val("");
    jQuery("input#other_order").val("");

    if (this.value == "Amazon") {
      jQuery("input#bodno_order").prop("disabled", true);
      jQuery("input#amazon_order").prop("disabled", false);
      jQuery("input#other_order").prop("disabled", true);
    }
    if (this.value == "Bodno") {
      jQuery("input#bodno_order").prop("disabled", false);
      jQuery("input#amazon_order").prop("disabled", true);
      jQuery("input#other_order").prop("disabled", true);
    }
    if (this.value == "Other") {
      jQuery("input#bodno_order").prop("disabled", true);
      jQuery("input#amazon_order").prop("disabled", true);
      jQuery("input#other_order").prop("disabled", false);
    }
  });

  jQuery("#country").change(function () {
    if (jQuery("#country").val() == "Canada") {
      jQuery("#state").html(
        '<option value="Alberta">Alberta</option><option value="British Columbia">British Columbia</option><option value="Manitoba">Manitoba</option><option value="New Brunswick">New Brunswick</option><option value="Newfoundland">Newfoundland</option><option value="Northwest Territories">Northwest Territories</option><option value="Nova Scotia">Nova Scotia</option><option value="Nunavut">Nunavut</option><option value="Ontario">Ontario</option><option value="Prince Edward Island">Prince Edward Island</option><option value="Quebec">Quebec</option><option value="Saskatchewan">Saskatchewan</option><option value="Yukon">Yukon</option>'
      );
    }
    if (jQuery("#country").val() == "United States") {
      jQuery("#state").html(
        '<option value="Alabama">Alabama</option><option value="Alaska">Alaska</option><option value="American Samoa">American Samoa</option><option value="Arizona">Arizona</option><option value="Arkansas">Arkansas</option><option value="California">California</option><option value="Colorado">Colorado</option><option value="Connecticut">Connecticut</option><option value="Delaware">Delaware</option><option value="Florida">Florida</option><option value="Georgia">Georgia</option><option value="Guam">Guam</option><option value="Hawaii">Hawaii</option><option value="Idaho">Idaho</option><option value="Illinois">Illinois</option><option value="Indiana">Indiana</option><option value="Iowa">Iowa</option><option value="Kansas">Kansas</option><option value="Kentucky">Kentucky</option><option value="Louisiana">Louisiana</option><option value="Maine">Maine</option><option value="Marshall Islands">Marshall Islands</option><option value="Maryland">Maryland</option><option value="Massachusetts">Massachusetts</option><option value="Michigan">Michigan</option><option value="Micronesia">Micronesia</option><option value="Minnesota">Minnesota</option><option value="Mississippi">Mississippi</option><option value="Missouri">Missouri</option><option value="Montana">Montana</option><option value="Nebraska">Nebraska</option><option value="Nevada">Nevada</option><option value=">New Hampshire">New Hampshire</option><option value="New Jersey">New Jersey</option><option value="New Mexico">New Mexico</option><option value="New York">New York</option><option value="North Carolina">North Carolina</option><option value="North Dakota">North Dakota</option><option value="Northern Mariana Islands">Northern Mariana Islands</option><option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option><option value="Oregon">Oregon</option><option value="Palau">Palau</option><option value="Pennsylvania">Pennsylvania</option><option value="Puerto Rico">Puerto Rico</option><option value="Rhode Island">Rhode Island</option><option value="South Carolina">South Carolina</option><option value="South Dakota">South Dakota</option><option value="Tennessee">Tennessee</option><option value="Texas">Texas</option><option value="U.S. Virgin Islands">U.S. Virgin Islands</option><option value="Utah">Utah</option><option value="Vermont">Vermont</option><option value="Virginia">Virginia</option><option value="Washington">Washington</option><option value="Washington DC">Washington DC</option><option value="West Virginia">West Virginia</option><option value="Wisconsin">Wisconsin</option><option value="Wyoming">Wyoming</option><option value="Armed Forces Americas">Armed Forces Americas</option><option value="Armed Forces Europe">Armed Forces Europe</option><option value="Armed Forces Pacific">Armed Forces Pacific</option>'
      );
    }

    if (jQuery("#country").val() == "Guyana") {
      jQuery("#state").html('<option value="--"> -- </option>');
    }
    if (jQuery("#country").val() == "Jamaica") {
      jQuery("#state").html('<option value="--"> -- </option>');
    }
  });

  // jQuery(document).on("click", "#submit-register-your-printer", function (e) {
  //   e.preventDefault();

  //   var first_name_input = jQuery('input[name="first_name"]').val();
  //   var last_name_input = jQuery('input[name="last_name"]').val();
  //   var company_name_input = jQuery('input[name="company_name"]').val();
  //   var email_input = jQuery('input[name="email"]').val();
  //   var phone_number_input = jQuery('input[name="phone_number"]').val();
  //   var serial_number_input = jQuery('input[name="serial_number"]').val();
  //   var address_input = jQuery('input[name="address"]').val();
  //   var city_input = jQuery('input[name="city"]').val();
  //   var state_input = jQuery('select[name="state"]').val();
  //   var zipcode_input = jQuery('input[name="zipcode"]').val();
  //   var amazon_order_input = jQuery('input[name="amazon_order"]').val();
  //   var bodno_order_input = jQuery('input[name="bodno_order"]').val();
  //   var other_order_input = jQuery('input[name="other_order"]').val();
  //   var order_from_input = jQuery("input[type=radio][name=order_from]").val();

  //   if (first_name_input == "undefined" || first_name_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your First Name!</div>'
  //     );
  //     jQuery('input[name="first_name"]').focus();
  //     return;
  //   }
  //   if (last_name_input == "undefined" || last_name_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your Last Name!</div>'
  //     );
  //     jQuery('input[name="last_name"]').focus();
  //     return;
  //   }
  //   if (company_name_input == "undefined" || company_name_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your Company Name!</div>'
  //     );
  //     jQuery('input[name="company_name"]').focus();
  //     return;
  //   }
  //   if (phone_number_input == "undefined" || phone_number_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your Phone Number!</div>'
  //     );
  //     jQuery('input[name="phone_number"]').focus();
  //     return;
  //   }

  //   if (email_input == "undefined" || email_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your Email!</div>'
  //     );
  //     jQuery('input[name="email"]').focus();
  //     return;
  //   }
  //   if (!validateEmail(email_input)) {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter A Valid Email!</div>'
  //     );
  //     jQuery('input[name="email"]').focus();
  //     return;
  //   }

  //   if (serial_number_input == "undefined" || serial_number_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your Printer Serial Number!</div>'
  //     );
  //     jQuery('input[name="serial_number"]').focus();
  //     return;
  //   }

  //   if (address_input == "undefined" || address_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your Address!</div>'
  //     );
  //     jQuery('input[name="address"]').focus();
  //     return;
  //   }
  //   if (city_input == "undefined" || city_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your City Name!</div>'
  //     );
  //     jQuery('input[name="city"]').focus();
  //     return;
  //   }
  //   if (state_input == "undefined" || state_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Select Your State!</div>'
  //     );
  //     jQuery('input[name="state"]').focus();
  //     return;
  //   }
  //   if (zipcode_input == "undefined" || zipcode_input == "") {
  //     jQuery(".error-msg").show();
  //     jQuery(".error-msg").html(
  //       '<div class="alert alert-warning">Please Enter Your Zip Code!</div>'
  //     );
  //     jQuery('input[name="zipcode"]').focus();
  //     return;
  //   }

  //   if (amazon_order_input == "undefined" || amazon_order_input == "") {
  //     if (bodno_order_input == "undefined" || bodno_order_input == "") {
  //       if (other_order_input == "undefined" || other_order_input == "") {
  //         jQuery(".error-msg").show();
  //         jQuery(".error-msg").html(
  //           '<div class="alert alert-warning">Please Enter Your Order Number!</div>'
  //         );
  //         return;
  //       }
  //     }
  //   }

  //   if (
  //     email_input !== "undefined" &&
  //     first_name_input !== "undefined" &&
  //     last_name_input !== "undefined" &&
  //     company_name_input !== "undefined" &&
  //     phone_number_input !== "undefined" &&
  //     serial_number_input !== "undefined" &&
  //     address_input !== "undefined" &&
  //     city_input !== "undefined" &&
  //     state_input !== "undefined" &&
  //     zipcode_input !== "undefined"
  //   ) {
  //     jQuery(".error-msg").hide();
  //     jQuery(".register-your-printer-loading").show();

  //     jQuery.ajax({
  //       url: "https://api.bodno.com/registered-printer/post",
  //       type: "post",
  //       data: JSON.stringify({
  //         first_name: first_name_input,
  //         last_name: last_name_input,
  //         company_name: company_name_input,
  //         email: email_input,
  //         phone_number: phone_number_input,
  //         serial_number: serial_number_input,
  //         address: address_input,
  //         city: city_input,
  //         state: state_input,
  //         zipcode: zipcode_input,
  //         amazon_order: amazon_order_input,
  //         bodno_order: bodno_order_input,
  //         other_order: other_order_input,
  //       }),
  //       success: function (response) {
  //         //console.log(response);
  //         if (response["status"] == "200") {
  //           jQuery(".register-your-printer-loading").hide();
  //           jQuery(".error-msg").hide();
  //           jQuery(".register-your-printer .steps li").removeClass("active");
  //           jQuery(
  //             '.register-your-printer .steps li[data-page="driver"]'
  //           ).addClass("active");
  //           jQuery(".register-your-printer-page").hide();
  //           jQuery(".driver").show();
  //           jQuery("#register-your-printer .success-msg").show();
  //           jQuery(".license-info").html(
  //             '<div class="alert alert-success"><strong>Congratulation!</strong> Your Printer Registered Successfully & Your Software Activation Key Is: "<strong>' +
  //               response["activation_key"] +
  //               '</strong>"</div>'
  //           );
  //         } else {
  //           jQuery(".register-your-printer-loading").hide();
  //           jQuery(".error-msg").show();
  //           jQuery(".error-msg").html(
  //             '<div class="alert alert-danger">' +
  //               response["message"] +
  //               "</div>"
  //           );
  //         }

  //         return;
  //       },
  //     });
  //   }
  // });

  jQuery(document).on("click", ".__auto_select_leasing", function (e) {
    var selected = jQuery(this).data("select");
    setTimeout(function () {
      if (selected == "Magicard300") {
        jQuery("#108237-select").val(
          "Magicard 300 Dual Sided ID Card Printer $99/m"
        );
      }
      if (selected == "Badgy100") {
        jQuery("#108237-select").val("Badgy 100 Card Printer $49/m");
      }
    }, 1000);
  });

  jQuery(document).on("click", ".call_to-action .close_icon", function (e) {
    jQuery(".call_to-action").remove();
  });

  jQuery(window).scroll(function () {
    var width = $(window).width();
    scroll = jQuery(window).scrollTop();
    if (width > 1024) {
      if (scroll >= 650) jQuery(".call_to-action").show();
      else jQuery(".call_to-action").hide();
    }
  });

  // jQuery(window).on('load', function() {
  //     const smbBtn = $('.free-pre-quotation .wizard__submit').html();
  //     //console.log(smbBtn);
  //     //const smbBtnNew = smbBtn.replace('<span class="spinner"></span>Submit', '<span class="spinner"></span>Speak with Sales');
  //     //console.log(smbBtnNew);
  //     $('.free-pre-quotation .wizard__submit').html(smbBtnNew);
  // });

  jQuery(document).on("click", "#submit_cancellation", function (e) {
    e.preventDefault();

    var email_input = jQuery('input[id="email"]').val();
    var activation_key_input = jQuery('input[id="activation_key"]').val();

    if (email_input == "undefined" || email_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Email!</div>'
      );
      return;
    }
    if (!validateEmail(email_input)) {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter A Valid Email!</div>'
      );
      return;
    }
    if (activation_key_input == "undefined" || activation_key_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Activation Code!</div>'
      );
      return;
    }

    if (email_input !== "undefined" && activation_key_input !== "undefined") {
      jQuery(".error-msg").hide();
      jQuery.ajax({
        url: "https://api.bodno.com/verify-subscription",
        type: "post",
        data: JSON.stringify({
          email: email_input,
          activation_code: activation_key_input,
        }),
        success: function (response) {
          if (response["status"] == "200") {
            jQuery("form#cancellation").trigger("reset");
            jQuery("#cancellation .success-msg").show();
          } else {
            jQuery(".error-msg").show();
            jQuery(".error-msg").html(
              '<div class="alert alert-warning">' +
                response["message"] +
                "</div>"
            );
          }
          return;
        },
      });
    }
  });

  jQuery(document).on("click", "#check_status", function (e) {
    e.preventDefault();
    var license_key_input = jQuery('input[id="license"]').val();
    if (license_key_input == "undefined" || license_key_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Bodno License Key!</div>'
      );
      return;
    }

    if (license_key_input !== "undefined") {
      jQuery(".error-msg").hide();
      jQuery("#ajax-loader-overlay").show();
      jQuery.ajax({
        url: "https://api.bodno.com/check-status",
        type: "post",
        data: JSON.stringify({ license: license_key_input }),
        success: function (response) {
          jQuery("#ajax-loader-overlay").hide();
          if (response["status"] != "404") {
            //jQuery("form#check-status").trigger("reset");
            if (response["status"] == "Active") {
              if (response["type"] == "lifetime"){
                 var license_about_info =
                "Your USB license is active and your Bodno software is fully licensed. This is a Lifetime USB License (now discontinued, but existing lifetime licenses remain valid).";
              }else{
                 var license_about_info =
                "Your USB license is active and your Bodno software is fully licensed. USB dongles are discontinued industry-wide. When convenient, we recommend moving to activation codes for a smoother long-term setup.";
              }
             
              var license_about_info_icon =
                '<svg width="16" height="17" viewB/ox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.84141C9.37447 2.62031 8.70127 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 8.04173 13.9486 7.59547 13.8513 7.16667M5.66667 8.5L7.33333 10.1667L10.4461 6.98665" stroke="#006B44" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            } else if (response["status"] == "Expired") {
              var license_about_info =
                "Your USB dongle license has expired and USB dongles are no longer supported. Your printer remains fully operational. To restore software access, purchase an activation code.";
              var license_about_info_icon =
                '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6.49997L8 8.49997M8 8.49997L10 10.5M8 8.49997L6 10.5M8 8.49997L10 6.49997M14 8.49991C14 11.8136 11.3137 14.4999 8 14.4999C4.68629 14.4999 2 11.8136 2 8.49991C2 5.18623 4.68629 2.49994 8 2.49994C11.3137 2.49994 14 5.18623 14 8.49991Z" stroke="#820000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            } else if (response["status"] == "Expiring Soon") {
              var license_about_info =
                "Your USB dongle license expires soon. After expiration, USB dongles are no longer supported. To avoid any interruption, purchase an activation code before it expires.";
              var license_about_info_icon =
                '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69977 12.3609C8.69977 12.7388 8.3865 13.0451 7.99999 13.0451C7.61349 13.0451 7.30021 12.7388 7.30021 12.3609C7.30021 11.983 7.61349 11.6767 7.99999 11.6767C8.3865 11.6767 8.69977 11.983 8.69977 12.3609ZM7.99999 6.10525C7.61354 6.10525 7.30021 6.41161 7.30021 6.78947V10.0151C7.30021 10.393 7.61354 10.6993 7.99999 10.6993C8.38644 10.6993 8.69977 10.393 8.69977 10.0151V6.78947C8.69977 6.41161 8.38644 6.10525 7.99999 6.10525ZM14.5064 13.3089C13.8743 14.3679 12.7576 15 11.5187 15H4.48128C3.24231 15 2.12567 14.3679 1.49357 13.3089C0.844369 12.2211 0.835127 10.9174 1.46863 9.82097L4.98734 3.73358C5.61468 2.64812 6.74089 2 8.00002 2C9.25914 2 10.3854 2.64812 11.0127 3.73358L14.5314 9.82097C15.1649 10.9174 15.1556 12.2211 14.5064 13.3089ZM13.3129 10.4945L9.79421 4.4071C9.41834 3.75663 8.74763 3.36843 7.99999 3.36843C7.25236 3.36843 6.58164 3.75663 6.20577 4.4071L2.68707 10.4945C2.3013 11.162 2.30677 11.9565 2.70243 12.6189C3.08068 13.253 3.7456 13.6315 4.48126 13.6315H11.5187C12.2543 13.6315 12.9192 13.253 13.2975 12.6189C13.6932 11.9565 13.6987 11.162 13.3129 10.4945Z" fill="#7A6200"/></svg>';
            }

            if (response["type"] == "lifetime"){
              var license_typed = 'USB Dongle (Lifetime)';
              var expirey_date_dongle = license_typed;
            }else{
              var license_typed = 'USB Dongle (5-year term)';
              var expirey_date_dongle = response["expiry_at"];
            }

          
            

            var html_response =
              '<div class="license-table">' +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">License Key</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem f--upper">' +
              response["license"] +
              "</div>" +
              "</div>" +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Software Edition</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">' +
              response["edition"] +
              "</div>" +
              "</div>" +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Activation Date</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">' +
              response["created_on"] +
              "</div>" +
              "</div>" +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Expiration Date</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">' +
              expirey_date_dongle +
              "</div>" +
              "</div>" +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">License Type</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">' + license_typed + '</div>' +
              "</div>" +
              '<div class="mt-3 bar-status ' +
              response["status"] +
              ' ">' +
              '<div class="d-flex align-items-start justify-content-between justify-content-md-start flex-nowrap gap-5">' +
              '<div class="f--1_125rem lh--loose f--bold-700 mf--1rem">License Status</div>' +
              '<div class="f--1_125rem lh--loose mf--1rem d-flex align-items-center gap-2">' +
              license_about_info_icon +
              " " +
              response["status"] +
              " </div>" +
              "</div>" +
              '<div class="mt-3 bar-status-info ' +
              response["status"] +
              '"><span class="f--0_875rem lh--loose f--black">' +
              license_about_info +
              "</span></div>";
            "</div>" + "</div>";
            jQuery("#check-status .success-msg").show();
            jQuery(".update_details").show();
            jQuery('input[id="update_detail_license"]').val(response["license"])

            jQuery("#check-status .success-msg").html(html_response);
          } else {
            jQuery("#check-status .success-msg").hide();
            jQuery(".update_details").hide();
            jQuery(".error-msg").show();
            jQuery(".error-msg").html(
              '<div class="alert alert-warning">' +
                response["message"] +
                "</div>"
            );
          }
          return;
        },
        error: function () {
          jQuery("#ajax-loader-overlay").hide(); // Hide loader on error too
           jQuery(".error-msg").html(
              '<div class="alert alert-warning">' +
                response["message"] +
                "</div>"
            );
        },
      });
    }
  });

  //Activation Key Status Check
   jQuery(document).on("click", "#check_status_activation", function (e) {
    e.preventDefault();
    var activationKey = jQuery('input[id="activation-key"]').val();
    if (activationKey == "undefined" || activationKey == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Bodno Activation Key!</div>'
      );
      return;
    }

    if (activationKey !== "undefined") {
      jQuery(".error-msg").hide();
      jQuery("#ajax-loader-overlay").show();
      jQuery.ajax({
        url: "https://api.bodno.com/status/check",
        type: "post",
        data: JSON.stringify({ activation_key: activationKey }),
        success: function (response) {
           jQuery("#ajax-loader-overlay").hide();
          if (response["status"] != "404") {

           
            
            //jQuery("form#check-status").trigger("reset");
            if (response["status"] == "Active") {
              switch (response.license_type) {
                case "one-time":
                  var license_about_info = "Your activation code is valid and your Bodno software is fully licensed. You’re all set to create, print, and design with confidence. Enjoy uninterrupted access to everything Bodno has to offer.";
                  break;
                case "lifetime":
                  var license_about_info = "Your Bodno software is fully licensed with a Lifetime Activation Code. You’re all set to create, print, and design with confidence. This Lifetime License does not expire.";
                  break;
                default: 
                  var license_about_info = "Your activation code is valid and your Bodno software is fully licensed. You’re all set to create, print, and design with confidence. Enjoy uninterrupted access to everything Bodno has to offer.";
              }
             
              var license_about_info_icon =
                '<svg width="16" height="17" viewB/ox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.84141C9.37447 2.62031 8.70127 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 8.04173 13.9486 7.59547 13.8513 7.16667M5.66667 8.5L7.33333 10.1667L10.4461 6.98665" stroke="#006B44" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
              var license_renew_button = '';
            } else if (response["status"] == "Expired") {
              switch (response.license_type) {
                case "one-time":
                  var license_about_info = "Your one-time license has expired, so Bodno software is no longer fully licensed on this device. To restore access, renew your activation code.";
                  break;
                default: 
                  var license_about_info = "Your subscription has expired, so Bodno software is no longer fully licensed on this device. To restore access, purchase a new subscription (monthly or yearly).";
              }
              var license_about_info_icon =
                '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6.49997L8 8.49997M8 8.49997L10 10.5M8 8.49997L6 10.5M8 8.49997L10 6.49997M14 8.49991C14 11.8136 11.3137 14.4999 8 14.4999C4.68629 14.4999 2 11.8136 2 8.49991C2 5.18623 4.68629 2.49994 8 2.49994C11.3137 2.49994 14 5.18623 14 8.49991Z" stroke="#820000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                 var license_renew_button = '<a class="btn btn--red btn--bold-700 btn--loose f--1_25rem mf--1_125rem mt-3 purchase-code">Buy a New Activation Code</a>';
            } else if (response["status"] == "Expiring Soon") {

              switch (response.license_type) {
                case "one-time":
                  var license_about_info = "Your one-time license expires soon. To continue without interruption, renew your activation code before it expires. Renewing now keeps you fully licensed and ready to print when you need it.";
                  break;
                default: 
                  var license_about_info = "Your subscription is active and scheduled to renew soon. No action is needed unless your payment method needs to be updated.";
              }
              var license_about_info_icon =
                '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69977 12.3609C8.69977 12.7388 8.3865 13.0451 7.99999 13.0451C7.61349 13.0451 7.30021 12.7388 7.30021 12.3609C7.30021 11.983 7.61349 11.6767 7.99999 11.6767C8.3865 11.6767 8.69977 11.983 8.69977 12.3609ZM7.99999 6.10525C7.61354 6.10525 7.30021 6.41161 7.30021 6.78947V10.0151C7.30021 10.393 7.61354 10.6993 7.99999 10.6993C8.38644 10.6993 8.69977 10.393 8.69977 10.0151V6.78947C8.69977 6.41161 8.38644 6.10525 7.99999 6.10525ZM14.5064 13.3089C13.8743 14.3679 12.7576 15 11.5187 15H4.48128C3.24231 15 2.12567 14.3679 1.49357 13.3089C0.844369 12.2211 0.835127 10.9174 1.46863 9.82097L4.98734 3.73358C5.61468 2.64812 6.74089 2 8.00002 2C9.25914 2 10.3854 2.64812 11.0127 3.73358L14.5314 9.82097C15.1649 10.9174 15.1556 12.2211 14.5064 13.3089ZM13.3129 10.4945L9.79421 4.4071C9.41834 3.75663 8.74763 3.36843 7.99999 3.36843C7.25236 3.36843 6.58164 3.75663 6.20577 4.4071L2.68707 10.4945C2.3013 11.162 2.30677 11.9565 2.70243 12.6189C3.08068 13.253 3.7456 13.6315 4.48126 13.6315H11.5187C12.2543 13.6315 12.9192 13.253 13.2975 12.6189C13.6932 11.9565 13.6987 11.162 13.3129 10.4945Z" fill="#7A6200"/></svg>';
              var license_renew_button = '<a class="btn btn--red btn--bold-700 btn--loose f--1_25rem mf--1_125rem mt-3 purchase-code">Renew or Purchase Activation Code</a>';
            }

            if(response.license_type == 'one-time'){
              var subscription_status = "One-Time License (3 Years)";
            }else if(response.license_type == 'lifetime'){
              var subscription_status = "LifeTime";
            }else if(response.license_type == 'monthly'){
              var subscription_status = "Yes - Monthly";
            }else if(response.license_type == 'yearly'){
              var subscription_status = "Yes - Yearly";
            }
            if(response.cancelled_at != null){
              var expirey_date = response.cancelled_at;
            } else{
              if(subscription_status == 'LifeTime'){
                expirey_date = subscription_status;
              }else{
                var expirey_date = response["expiry_at"];
              }
              
            }

            if(response.subscription == 1){
              var subscription_status_new = 'Yes';
            }else{
              var subscription_status_new = 'No';
            }

            if(response.subscription == 1 && response.cancelled_at != ""  ){
              var subscription_status_new = 'No';
            }
           

            // var subscription_status = "One-Time License (3 Years)";
            // var expirey_date = response["expiry_at"];
           
            
            var html_response =
              '<div class="license-table">' +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Activation Key</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem f--upper">' +
              response["activation_key"] +
              "</div>" +
              "</div>" +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Software Edition</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">' +
              response["edition"] +
              "</div>" +
              "</div>" +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Activation Date</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">' +
              response["created_on"] +
              "</div>" +
              "</div>" +
              '<div class="bar sub-'+subscription_status_new+'">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Expiration Date</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">' +
              expirey_date +
              "</div>" +
              "</div>" +
              '<div class="bar">' +
              '<div class="f--1_125rem lh--loose f--bold-700 f--black mf--1rem">Subscription</div>' +
              '<div class="f--1_125rem lh--loose f--black mf--1rem">'+ subscription_status +'</div>' +
              "</div>" +
              '<div class="mt-3 bar-status ' +
              response["status"] +
              ' ">' +
              '<div class="d-flex align-items-start justify-content-between justify-content-md-start flex-nowrap gap-5">' +
              '<div class="f--1_125rem lh--loose f--bold-700 mf--1rem">License Status</div>' +
              '<div class="f--1_125rem lh--loose mf--1rem d-flex align-items-center gap-2">' +
              license_about_info_icon +
              " " +
              response["status"] +
              " </div>" +
              "</div>" +
              '<div class="mt-3 bar-status-info ' +
              response["status"] +
              '"><span class="f--0_875rem lh--loose f--black">' +
              license_about_info +
              "</span></div>" +
            "</div>" + 
            license_renew_button +
            "</div>";
            jQuery("#check-status .success-msg").show();
            jQuery(".update_details").show();
            jQuery('input[id="update_detail_license"]').val(response["activation_key"])
            jQuery("#check-status .success-msg").html(html_response);
          } else {
            jQuery("#check-status .success-msg").hide();
            jQuery(".update_details").hide();
            jQuery(".error-msg").show();
            jQuery(".error-msg").html(
              '<div class="alert alert-warning">' +
                response["message"] +
                "</div>"
            );
          }
          return;
        },
        error: function () {
          jQuery("#ajax-loader-overlay").hide(); // Hide loader on error too
           jQuery(".error-msg").html(
              '<div class="alert alert-warning">' +
                response["message"] +
                "</div>"
            );
        },
      });
    }
  });

  jQuery(document).on("click", "#submit_details", function (e) {
    e.preventDefault();

    var first_name_input = jQuery('input[id="update_detail_first_name"]').val();
    var last_name_input = jQuery('input[id="update_detail_last_name"]').val();
    var email_input = jQuery('input[id="update_detail_email"]').val();
    var phone_input = jQuery('input[id="update_detail_phone"]').val();
    var license_input = jQuery('input[id="update_detail_license"]').val();

    if (first_name_input == "undefined" || first_name_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your First Name!</div>'
      );
      return;
    }

    if (last_name_input == "undefined" || last_name_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Last Name!</div>'
      );
      return;
    }

    if (email_input == "undefined" || email_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Email!</div>'
      );
      return;
    }

    if (phone_input == "undefined" || phone_input == "") {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter Your Phone Number!</div>'
      );
      return;
    }

    if (!validateEmail(email_input)) {
      jQuery(".error-msg").show();
      jQuery(".error-msg").html(
        '<div class="alert alert-warning">Please Enter A Valid Email!</div>'
      );
      return;
    }

    if (
      email_input !== "undefined" &&
      first_name_input !== "undefined" &&
      last_name_input !== "undefined" &&
      phone_input !== "undefined"
    ) {
      jQuery(".error-msg").hide();
      jQuery.ajax({
        url: "https://api.bodno.com/update-license-info",
        type: "post",
        data: JSON.stringify({
          first_name: first_name_input,
          last_name: last_name_input,
          email: email_input,
          license: license_input,
          phone: phone_input,
        }),
        success: function (response) {
          if (response["status"] != "404") {
            jQuery("form#update_detail").trigger("reset");
            jQuery("form#update_detail").hide();
            jQuery("#update-details .success-msg").show();
            return;
          } else {
            jQuery("#update-details .success-msg").hide();
            jQuery("#update-details .error-msg").show();
            jQuery("#update-details .error-msg").html(
              '<div class="alert alert-warning">' +
                response["message"] +
                "</div>"
            );
          }
          return;
        },
      });
    }
  });
});

if (document.getElementById("frequently-bought-together-btn")) {
  document
    .getElementById("frequently-bought-together-btn")
    .addEventListener("click", function () {
      setTimeout(function () {
        var hash = window.location.hash;

        // Check if there is a hash and if the element with that ID exists
        if (hash) {
          var target = document.querySelector(hash);
          if (target) {
            // Calculate the offset with a slight adjustment
            var rect = target.getBoundingClientRect();
            var offset = rect.top + window.scrollY;
            var adjustment = 160; // Adjust this value as needed

            // Set a timeout to scroll to the element after 5 seconds

            window.scrollTo({
              top: offset - adjustment,
              behavior: "smooth",
            });
          }
        }
      }, 600); // 5000 milliseconds = 5 seconds
    });
}

if (document.getElementById("whats-in-the-box-btn")) {
  document
    .getElementById("whats-in-the-box-btn")
    .addEventListener("click", function () {
      setTimeout(function () {
        var hash = window.location.hash;

        // Check if there is a hash and if the element with that ID exists
        if (hash) {
          var target = document.querySelector(hash);
          if (target) {
            // Calculate the offset with a slight adjustment
            var rect = target.getBoundingClientRect();
            var offset = rect.top + window.scrollY;
            var adjustment = 160; // Adjust this value as needed

            // Set a timeout to scroll to the element after 5 seconds

            window.scrollTo({
              top: offset - adjustment,
              behavior: "smooth",
            });
          }
        }
      }, 600); // 5000 milliseconds = 5 seconds
    });
}

if (document.getElementById("product-description-btn")) {
  document
    .getElementById("product-description-btn")
    .addEventListener("click", function () {
      setTimeout(function () {
        var hash = window.location.hash;

        // Check if there is a hash and if the element with that ID exists
        if (hash) {
          var target = document.querySelector(hash);
          if (target) {
            // Calculate the offset with a slight adjustment
            var rect = target.getBoundingClientRect();
            var offset = rect.top + window.scrollY;
            var adjustment = 160; // Adjust this value as needed

            // Set a timeout to scroll to the element after 5 seconds

            window.scrollTo({
              top: offset - adjustment,
              behavior: "smooth",
            });
          }
        }
      }, 600); // 5000 milliseconds = 5 seconds
    });
}

if (document.getElementById("software-description-btn")) {
  document
    .getElementById("software-description-btn")
    .addEventListener("click", function () {
      setTimeout(function () {
        var hash = window.location.hash;

        // Check if there is a hash and if the element with that ID exists
        if (hash) {
          var target = document.querySelector(hash);
          if (target) {
            // Calculate the offset with a slight adjustment
            var rect = target.getBoundingClientRect();
            var offset = rect.top + window.scrollY;
            var adjustment = 190; // Adjust this value as needed

            // Set a timeout to scroll to the element after 5 seconds

            window.scrollTo({
              top: offset - adjustment,
              behavior: "smooth",
            });
          }
        }
      }, 600); // 5000 milliseconds = 5 seconds
    });
}

if (document.getElementById("product-reviews-btn")) {
  document
    .getElementById("product-reviews-btn")
    .addEventListener("click", function () {
      setTimeout(function () {
        var hash = window.location.hash;

        // Check if there is a hash and if the element with that ID exists
        if (hash) {
          var target = document.querySelector(hash);
          if (target) {
            // Calculate the offset with a slight adjustment
            var rect = target.getBoundingClientRect();
            var offset = rect.top + window.scrollY;
            var adjustment = 160; // Adjust this value as needed

            // Set a timeout to scroll to the element after 5 seconds

            window.scrollTo({
              top: offset - adjustment,
            });
          }
        }
      }, 600); // 5000 milliseconds = 5 seconds
    });
}

$(document).ready(function () {
  $(".swatch-option label").click(function () {
    var fbt_current_variant_option_label = $(this).text().trim();
    var fbt_current_variant_title = $(
      ".__fbt_current_variant ._name_with_only_title"
    )
      .text()
      .trim();
    if (fbt_current_variant_option_label == "Dual Sided") {
      var fbt_current_variant_title_new = fbt_current_variant_title.replace(
        "Single Sided",
        "Dual Sided"
      );
    } else if (fbt_current_variant_option_label == "Single Sided") {
      var fbt_current_variant_title_new = fbt_current_variant_title.replace(
        "Dual Sided",
        "Single Sided"
      );
    } else {
      var fbt_current_variant_title_new = fbt_current_variant_title;
    }
    $(".__fbt_current_variant ._name_with_only_title").text(
      fbt_current_variant_title_new
    );

    setTimeout(function () {
      const varShortDEscription = document.querySelector(".short_description");
      if (varShortDEscription) {
        const varShortDEscriptionTxt = varShortDEscription.innerText;
        if (varShortDEscriptionTxt == "") {
          document.querySelector(".product.attibute.overview").style.display =
            "none";
        } else {
          document.querySelector(".product.attibute.overview").style.display =
            "block";
        }
      }
    }, 100);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const swatchOption = document.querySelectorAll(".supplies .swatch-option");
  if (swatchOption.length) {
    swatchOption.forEach(function (element) {
      element.addEventListener("click", function () {
        setTimeout(function () {
          const variantDescription = document.querySelector(
            "#product-description .prod-description-new.prod-description"
          );
          if (variantDescription) {
            const variantDescriptionTxt = variantDescription.innerText.trim();
            if (variantDescriptionTxt == "") {
              document.querySelector("#product-description").style.display =
                "none";
              if (document.querySelector("#product-description-btn")) document.querySelector("#product-description-btn").closest("li").style.display = "none"; // Oct 22 2026: null check (not on every product page)
              document.querySelector(
                "#product-ecom-key-features-list"
              ).style.display = "none";
            } else {
              document.querySelector("#product-description").style.display =
                "block";
              if (document.querySelector("#product-description-btn")) document.querySelector("#product-description-btn").closest("li").style.display = "flex"; // Oct 22 2026: null check (not on every product page)
              document.querySelector(
                "#product-ecom-key-features-list"
              ).style.display = "block";
            }
          }
        }, 300);
      });
    });
  }
});

window.addEventListener("load", function () {
  setTimeout(function () {
    const variantDescription = document.querySelector(
      "#product-description .prod-description-new.prod-description"
    );
    if (variantDescription) {
      const variantDescriptionTxt = variantDescription.innerText.trim();
      if (variantDescriptionTxt == "") {
        document.querySelector("#product-description").style.display = "none";
        if (document.querySelector("#product-description-btn")) document.querySelector("#product-description-btn").closest("li").style.display = "none"; // Oct 22 2026: null check (not on every product page)
        document.querySelector(
          "#product-ecom-key-features-list"
        ).style.display = "none";
      } else {
        document.querySelector("#product-description").style.display = "block";
        if (document.querySelector("#product-description-btn")) document.querySelector("#product-description-btn").closest("li").style.display = "flex"; // Oct 22 2026: null check (not on every product page)
        document.querySelector(
          "#product-ecom-key-features-list"
        ).style.display = "block";
      }
    }

    const softwareDescription = document.querySelector("#software-description");
    if (softwareDescription) {
      const softwareDescriptionTxt = softwareDescription.innerText.trim();
      if (softwareDescriptionTxt == "") {
        softwareDescription.style.display = "none";
      } else {
        softwareDescription.style.display = "block";
      }
    }
  }, 300);
});

window.onload = function () {
  setTimeout(() => {
    document
      .querySelectorAll(".industry-section-7 .label-content")
      .forEach((element) => {
        console.log(element.getAttribute("data-label"));
        if (element.getAttribute("data-label") === "Company / Industry") {
          element.setAttribute("data-label", "School Name/Location");
          element.textContent = "School Name/Location";
        }
      });

    document
      .querySelectorAll(
        ".industry-section-7 input[placeholder='Enter company / Industry']"
      )
      .forEach((input) => {
        input.setAttribute("placeholder", "Enter your School name/location");
      });
  }, 6000); // Runs after 5 seconds
};

/****** FOOTER SCRIPT FOR MOBILE ONLY **********/
if (window.innerWidth <= 768) {
  const coll = document.querySelectorAll(".footer-title-links");
  if (coll.length) {
    coll.forEach((button, index) => {
      button.addEventListener("click", function () {
        if (!this.closest("h5")) return; // Oct 22 2026: footer titles are <h3> now; the footer script in snippets/footer-script.liquid opens them
        this.closest("h5").classList.toggle("active");
        const footerDetailsContent = this.closest("h5").nextElementSibling;

        if (footerDetailsContent.style.display === "block") {
          footerDetailsContent.style.display = "none";
        } else {
          footerDetailsContent.style.display = "block";
        }
      });
    });
  }
}

// Click on Header Icon of Search open the search app
document.querySelector(".mobile-search")?.addEventListener("click", () => {
  const input = document.querySelector(".input-text");
  if (input) {
    // Simulate a real human interaction
    input.focus(); // optional: bring focus to the input
    input.click(); // trigger the click
  }
});

/******* Filter Mobile Button *************/
document.addEventListener("DOMContentLoaded", function () {
  const filterBtn = document.querySelector(".filter-btn");
  const closeBtn = document.querySelector(".filter-btn-close");
  const backdrop = document.querySelector(".backdrop-filter");
  const filtersWrapper = document.querySelector(".filters-wrapper");

  if (filterBtn && closeBtn && backdrop && filtersWrapper) {
    filterBtn.addEventListener("click", () => {
      backdrop.style.display = "block";
      filtersWrapper.style.display = "block";
    });

    closeBtn.addEventListener("click", () => {
      backdrop.style.display = "none";
      filtersWrapper.style.display = "none";
    });

    backdrop.addEventListener("click", (e) => {
      if (!filtersWrapper.contains(e.target)) {
        backdrop.style.display = "none";
        filtersWrapper.style.display = "none";
      }
    });
  } else {
    console.warn("One or more elements are missing in the DOM");
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const SCROLL_TARGET = "#collection-category-wrapper";
//   const SCROLL_OFFSET = 150;

//   function scrollWithOffset(selector, offset = 100) {
//     const el = document.querySelector(selector);
//     if (el) {
//       const top = el.getBoundingClientRect().top + window.scrollY - offset;
//       console.log("Scrolling to", selector);
//       window.scrollTo({ top, behavior: "smooth" });
//     } else {
//       console.warn("Scroll target not found:", selector);
//     }
//   }

//   function waitForCheckbox(filterName, filterValue, callback, timeout = 3000) {
//     const start = Date.now();
//     const interval = setInterval(() => {
//       const checkbox = document.querySelector(`input[type="checkbox"][name="${filterName}"][value="${filterValue}"]`);
//       const timedOut = Date.now() - start > timeout;
//       if (checkbox || timedOut) {
//         clearInterval(interval);
//         if (checkbox) {
//           console.log("Checkbox appeared:", filterValue);
//           callback(checkbox);
//         } else {
//           console.warn("Checkbox never appeared:", filterValue);
//         }
//       }
//     }, 100);
//   }

//   function resetFiltersThenApply(filterName, filterValue) {
//     console.log("Applying filter:", filterName, "=", filterValue);

//     const clearBtn = document.querySelector(".active-facets__button-remove");

//     if (clearBtn) {
//       console.log("Clicking clear all button");
//       clearBtn.click();

//       waitForCheckbox(filterName, filterValue, (checkbox) => {
//         if (!checkbox.checked) {
//           checkbox.click();
//           console.log("Clicked checkbox:", checkbox);

//           // Scroll after checkbox click
//           setTimeout(() => {
//             scrollWithOffset(SCROLL_TARGET, SCROLL_OFFSET);
//           }, 300);
//         } else {
//           console.log("Checkbox already checked, skipping");
//         }
//       });
//     } else {
//       // No filters to clear, apply directly
//       const checkbox = document.querySelector(`input[type="checkbox"][name="${filterName}"][value="${filterValue}"]`);
//       if (checkbox && !checkbox.checked) {
//         checkbox.click();
//         console.log("Clicked checkbox immediately:", checkbox);

//         setTimeout(() => {
//           scrollWithOffset(SCROLL_TARGET, SCROLL_OFFSET);
//         }, 300);
//       } else {
//         console.warn("Checkbox not found or already checked.");
//       }
//     }
//   }

//   function handleFilterClick(e) {
//     e.preventDefault();
//     const el = e.currentTarget;
//     const filterValue = el.getAttribute("filter-value");
//     if (!filterValue) {
//       console.warn("No filter-value on element", el);
//       return;
//     }

//     const isLicence = el.classList.contains("see-printer");
//     const isCaseStudy = el.classList.contains("see-printer-sector");

//     let filterName = "";
//     if (isLicence) filterName = "filter.p.m.info.licence";
//     if (isCaseStudy) filterName = "filter.p.m.info.case_study";
//     if (!filterName) return;

//     history.replaceState(null, '', window.location.pathname);
//     resetFiltersThenApply(filterName, filterValue);
//   }

//   // Attach listeners
//   document.querySelectorAll(".see-printer, .see-printer-sector").forEach(el => {
//     el.addEventListener("click", handleFilterClick);
//   });

//   console.log("Filter handlers attached.");
// });

document.addEventListener("DOMContentLoaded", function () {
  const SCROLL_TARGET = "#collection-category-wrapper";
  const SCROLL_OFFSET = 150;

  function scrollWithOffset(selector, offset = 100) {
    const el = document.querySelector(selector);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }

  function waitForElement(selector, callback, timeout = 8000) {
    const start = Date.now();
    const interval = setInterval(() => {
      const el = document.querySelector(selector);
      const expired = Date.now() - start > timeout;
      if (el || expired) {
        clearInterval(interval);
        if (el) callback(el);
      }
    }, 1500);
  }

  function applyFilter(filterName, filterValue, scrollAfter = true) {
    const clearBtn = document.querySelector(".active-facets__button-remove");

    if (clearBtn) {
      clearBtn.click();
    }

    waitForElement(
      `input[type="checkbox"][name="${filterName}"][value="${filterValue}"]`,
      (checkbox) => {
        if (!checkbox.checked) checkbox.click();

        if (scrollAfter) {
          setTimeout(() => {
            scrollWithOffset(SCROLL_TARGET, SCROLL_OFFSET);
          }, 1500); // Wait for content layout to stabilize
        }
      }
    );
  }

  function handleFilterClick(e) {
    e.preventDefault();
    const el = e.currentTarget;
    const filterValue = el.getAttribute("filter-value");

    let filterName = "";
    if (el.classList.contains("see-printer")) {
      filterName = "filter.p.m.info.licence";
    } else if (el.classList.contains("see-printer-sector")) {
      filterName = "filter.p.m.info.case_study";
    }

    if (!filterValue || !filterName) return;

    history.replaceState(null, "", window.location.pathname);
    applyFilter(filterName, filterValue);
  }

  // Bind event to both button types
  document
    .querySelectorAll(".see-printer, .see-printer-sector")
    .forEach((el) => {
      el.addEventListener("click", handleFilterClick);
    });
});

//check the collection page and pagination exist then scoll
window.addEventListener("load", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const hasPageParam = urlParams.has("page");
  const offset = 150; // Adjust for sticky header
  const sectionSelector = "#collection-category-wrapper";

  const isCollectionPage = window.location.pathname.includes("/collections/");

  if (isCollectionPage && hasPageParam) {
    const el = document.querySelector(sectionSelector);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }
});

 document.addEventListener('DOMContentLoaded', function () {
    const chatLinks = document.querySelectorAll('a[href="#live-chat"]');

    chatLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        function openChatWhenReady() {
          if (window.HubSpotConversations && window.HubSpotConversations.widget) {
            window.HubSpotConversations.widget.open();
          } else {
            setTimeout(openChatWhenReady, 300); // Retry if not yet loaded
          }
        }

        openChatWhenReady();
      });
    });
  });

//Models 


document.querySelectorAll(".openModalBtn").forEach(button => {
  button.addEventListener("click", function () {
    // Main modal content
    const title = this.getAttribute("data-title");
    const body = this.getAttribute("data-body");
    document.getElementById("modalTitle").textContent = title;
    document.getElementById("modalBody").textContent = body;

    document.getElementById("modalTitle-sale").textContent = title;
    document.getElementById("modalBody-sale").textContent = body;

    document.getElementById("modalTitle-rental").textContent = title;
    document.getElementById("modalBody-rental").textContent = body;

    // Thank you modal content (only update if attributes exist)
    const welcomeTitle = this.getAttribute("data-welcometitle");
    const welcomeBody = this.getAttribute("data-welcomebody");
    const welcomeBtnText = this.getAttribute("data-welcomebtntext");

    if (welcomeTitle) {
      document.getElementById("customModalLabel1").textContent = welcomeTitle;
    }
    if (welcomeBody) {
      document.getElementById("customModalLabel1-body").textContent = welcomeBody;
    }
    if (welcomeBtnText != "") {
      document.getElementById("customModalLabel1-footer-btn").textContent = welcomeBtnText;
    }else{
      document.getElementById("customModalLabel1-footer-btn").style.display = 'none';
    }
  });
});

  document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    const type = params.get("type"); // "__monthly", "__yearly", "__onetime"
    console.log(type);
    if (!type) return;

    document.querySelectorAll(".__software-pricing").forEach(item => {
      item.classList.remove("active");
      console.log(item.dataset.type);
      if (item.dataset.type === type) {
        item.classList.add("active");
      }
    });
  });